import React, { Component } from 'react';
import { connect } from 'react-redux';

import { discard, shouldFetch } from 'actions/cards';
import { begin } from 'actions/storylet';
import { IAppState } from 'types/app';
import { ICard } from 'types/cards';

import Card from './Card';
import DiscardButton from './DiscardButton';

type OwnProps = {
  data: ICard,
  dispatch: Function,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

class CardContainer extends Component<Props, {}> {
  static displayName = "CardContainer";

  /**
   * Discard
   * @return {undefined}
   */
  discardCard = () => {
    const { data, dispatch, disabled } = this.props;
    // If we are already doing some API work, then don't do anything
    if (disabled) {
      return;
    }
    dispatch(discard(data.eventId));
  };

  /**
   * Play
   * @return {undefined}
   */
  playCard = () => {
    const { data, dispatch, disabled } = this.props;
    // If we are already doing some API work, then don't do anything
    if (disabled) {
      return;
    }
    const {isAutofire, eventId} = data;
    if(isAutofire){
      dispatch(shouldFetch());
    }
    dispatch(begin(eventId));
  };

  isUndiscardable = () => {
    const { data: { stickiness } } = this.props;
    return stickiness === 'Sticky';
  };

  render = () => {
    const { data: { eventId } } = this.props;
    return (
      <div
        className="hand__card-container"
        data-event-id={eventId}
      >
        <Card
          {...this.props}
          onClick={this.playCard}
        />
        <DiscardButton
          {...this.props}
          onClick={this.discardCard}
          undiscardable={this.isUndiscardable()}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  cards: { isFetching },
  storylet: { isChoosing },
}: IAppState) => ({
  disabled: isChoosing || isFetching,
});

export default connect(mapStateToProps)(CardContainer);